module.exports = __webpack_public_path__ + "static/media/mini_logo.835d3b25.svg";